/* eslint no-console:0 */

let microsoftSubmitInProgress = false;
let microsoftInitStarted = false;
let microsoftLoginStarted = false;

function normalizeTenantId(rawTenantId) {
  const raw = String(rawTenantId || '').trim();
  if (!raw) {
    return '';
  }

  // Accepted authority tenants in Entra ID.
  if (['common', 'organizations', 'consumers'].includes(raw)) {
    return raw;
  }

  // Keep the first GUID-looking token if extra characters were injected.
  const guid = raw.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
  return guid ? guid[0] : raw;
}

function normalizeClientId(rawClientId) {
  const raw = String(rawClientId || '').trim();
  if (!raw) {
    return '';
  }
  const guid = raw.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
  return guid ? guid[0] : raw;
}

function hasMicrosoftRedirectHash() {
  const hash = window.location.hash || '';
  return hash.includes('code=') || hash.includes('id_token=') || hash.includes('error=');
}

function setMicrosoftAuthProcessingUI(enabled) {
  if (enabled) {
    document.documentElement.classList.add('microsoft-auth-processing');
  } else {
    document.documentElement.classList.remove('microsoft-auth-processing');
  }
}

function submitMicrosoftToken(token) {
  if (!token || microsoftSubmitInProgress) {
    return;
  }
  microsoftSubmitInProgress = true;

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/auth/sign_in';
  form.style.display = 'none';

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'microsoft_token';
  tokenInput.value = token;
  form.appendChild(tokenInput);

  if (csrfToken) {
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = 'authenticity_token';
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }

  document.body.appendChild(form);
  form.submit();
}

function handleMicrosoftLoginResponse(response) {
  const idToken = response && (response.idToken || response.idTokenRaw);
  if (idToken) {
    submitMicrosoftToken(idToken);
  }
}

function attachMicrosoftSignInButton(msalInstance) {
  const bindClick = () => {
    const button = document.getElementById('microsoft-signin-button');
    if (!button || button.dataset.microsoftBound === '1') {
      return;
    }
    button.dataset.microsoftBound = '1';

    button.addEventListener('click', (event) => {
      event.preventDefault();
      if (microsoftLoginStarted) {
        return;
      }
      microsoftLoginStarted = true;
      button.disabled = true;

      const loginRequest = {
        scopes: ['openid', 'profile', 'email'],
        prompt: 'select_account'
      };
      msalInstance.loginRedirect(loginRequest).catch((err) => {
        microsoftLoginStarted = false;
        button.disabled = false;
        console.error('MSAL loginRedirect:', err);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindClick, { once: true });
  } else {
    bindClick();
  }
}

function initializeMicrosoftSignIn() {
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path !== '/auth/sign_in') {
    return;
  }

  if (microsoftInitStarted) {
    return;
  }

  const Msal = window.msal;
  if (!Msal || !Msal.PublicClientApplication) {
    setTimeout(initializeMicrosoftSignIn, 100);
    return;
  }

  const clientId = normalizeClientId(window.MICROSOFT_CLIENT_ID);
  const tenantId = normalizeTenantId(window.MICROSOFT_TENANT_ID);
  if (!clientId || !tenantId) {
    // Config is injected in the login view body; pack may run before it's set.
    setTimeout(initializeMicrosoftSignIn, 100);
    return;
  }

  microsoftInitStarted = true;

  const processingRedirect = hasMicrosoftRedirectHash();
  if (processingRedirect) {
    setMicrosoftAuthProcessingUI(true);
  }

  const redirectUri = `${window.location.origin}/auth/sign_in`;
  const msalConfig = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri
    },
    cache: {
      cacheLocation: 'localStorage'
    }
  };

  const msalInstance = new Msal.PublicClientApplication(msalConfig);

  msalInstance
    .initialize()
    .then(() => msalInstance.handleRedirectPromise())
    .then((response) => {
      if (response && (response.idToken || response.idTokenRaw)) {
        if (window.location.hash) {
          window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
        }
        handleMicrosoftLoginResponse(response);
        return;
      }
      // Some browser/tenant combinations return no redirect response even after successful auth.
      // Recover from cached account and complete login silently.
      if (processingRedirect) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts && accounts.length > 0) {
          return msalInstance.acquireTokenSilent({
            account: accounts[0],
            scopes: ['openid', 'profile', 'email']
          }).then((silentResponse) => {
            if (silentResponse && (silentResponse.idToken || silentResponse.idTokenRaw)) {
              handleMicrosoftLoginResponse(silentResponse);
            }
          }).catch((err) => {
            console.error('MSAL acquireTokenSilent fallback:', err);
          });
        }
      }
    })
    .catch((err) => {
      setMicrosoftAuthProcessingUI(false);
      microsoftLoginStarted = false;
      console.error('MSAL initialize / handleRedirectPromise:', err);
    })
    .finally(() => {
      if (!microsoftSubmitInProgress) {
        setMicrosoftAuthProcessingUI(false);
      }
      attachMicrosoftSignInButton(msalInstance);
    });
}

initializeMicrosoftSignIn();
